import { ReactElement, ReactNode } from "react";
import { Dialog } from "primereact/dialog";

interface BlockConfirmationPopUpProps {
  visible: boolean;
  footerContent?: ReactElement | ReactNode;
  header: string | ReactNode;
  content: ReactNode;
  isHeadLess?: boolean;
  style?: any;
  className?: string;
  closable?: boolean;
  contentClassName?: string;
  onHide?: () => void;
  contentWrapperClassName?: string;
}

const BlockPopup = ({
  visible,
  footerContent,
  header,
  content,
  isHeadLess = false,
  closable = false,
  style = { width: "80vw" },
  className = "!w-[80vw]",
  contentClassName = "",
  contentWrapperClassName = "",
  onHide = () => {},
}: BlockConfirmationPopUpProps) => (
  <div className="card  block-pop-up flex justify-content-center">
    <Dialog
      header={!isHeadLess ? header : null}
      visible={visible}
      closable={closable}
      style={style}
      draggable={false}
      closeOnEscape={false}
      className={`${className} dark:text-dark-color`}
      onHide={onHide}
      footer={footerContent || undefined}
      keepInViewport
      contentClassName={`dark:text-dark-color ${contentClassName}`}
      headerClassName="dark:text-dark-color"
      maskClassName="dark:text-dark-color"
    >
      <div className={`m-0 ${contentWrapperClassName}`}>{content}</div>
    </Dialog>
  </div>
);

export default BlockPopup;
